export default __webpack_public_path__ + "static/media/lds-logo_is.178c30f3add27f2c.svg";